import {
  type QueryClient,
  type QueryKey,
  useQuery,
  type UseQueryReturnType,
} from "@tanstack/vue-query";
import { infiniteQueryOptions, queryOptions } from "@tanstack/vue-query";
import {
  type Collection,
  Comment,
  type CommentableResource,
  type CommentEntity,
} from "~/src/api";

export const useInfiniteCommentQuery = (
  key: QueryKey,
  feedType: CommentableResource,
  feedId: string,
  parentId?: string,
) => {
  return infiniteQueryOptions({
    queryKey: key,
    queryFn: async ({ pageParam = 0 }) => {
      const res = await Comment.search(feedType, feedId, {
        parentId,
        offset: pageParam as number,
        limit: 3,
        order: {
          createdAt: "desc",
        },
        includes: ["user", "profile_frame", "organization", "badge"],
        showDeleted: false,
      });
      console.log(parentId, "replies", res);
      return res;
    },
    initialPageParam: 0,
    getNextPageParam: (prev, pages) => {
      if (prev && prev.meta.offset + prev.meta.limit >= prev.meta.total)
        return null;
      return prev.meta.offset + prev.meta.limit;
    },
    select: (data) =>
      data.pages.toReversed().flatMap((page) => page.data.toReversed()),
    staleTime: 1000 * 60 * 5,
  });
};

export const useCachedInfiniteCommentQuery = (key: QueryKey) => {
  return queryOptions<
    | undefined
    | {
        pages: Collection<CommentEntity>[];
        pageParams: number[];
      },
    Error
  >({
    queryKey: key,
    enabled: false,
  });
};

export const getCachedInfiniteCommentQuery = (
  queryClient: QueryClient,
  key: QueryKey,
): UseQueryReturnType<
  {
    pages: Collection<CommentEntity>[];
    pageParams: number[];
  },
  Error
> => {
  return useQuery({
    queryKey: key,
    enabled: false,
  });
};
